import { render } from "./NewDonor.vue?vue&type=template&id=6d097398&scoped=true"
import script from "./NewDonor.vue?vue&type=script&lang=js"
export * from "./NewDonor.vue?vue&type=script&lang=js"

import "./NewDonor.vue?vue&type=style&index=0&id=6d097398&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d097398"]])

export default __exports__